export function SignOut(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="currentColor"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className="h-6 w-6"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 19H10.5C10.7761 19 11 19.2239 11 19.5V20.5C11 20.7761 10.7761 21 10.5 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H10.5C10.7761 3 11 3.22386 11 3.5V4.5C11 4.77614 10.7761 5 10.5 5H5V19ZM15.64 6.15L20.78 11.28C20.9189 11.4217 20.9977 11.6116 21 11.81V12.19C20.9998 12.3888 20.9207 12.5795 20.78 12.72L15.64 17.85C15.5461 17.9447 15.4183 17.9979 15.285 17.9979C15.1517 17.9979 15.0239 17.9447 14.93 17.85L14.22 17.15C14.1253 17.0561 14.0721 16.9283 14.0721 16.795C14.0721 16.6617 14.1253 16.5339 14.22 16.44L17.67 13H7.5C7.22386 13 7 12.7761 7 12.5V11.5C7 11.2239 7.22386 11 7.5 11H17.67L14.22 7.56C14.1259 7.46784 14.0729 7.34169 14.0729 7.21C14.0729 7.07831 14.1259 6.95216 14.22 6.86L14.93 6.15C15.0239 6.05534 15.1517 6.0021 15.285 6.0021C15.4183 6.0021 15.5461 6.05534 15.64 6.15Z"
      />{' '}
    </svg>
  );
}
